<template>
  <div class="participant">
    <div class="participant-head">Participants</div>
    <div class="participant-list">
      <ParticipantsCardItem
        v-for="item in items"
        :key="item.id"
        :data="item"
        @click="handelItem(item)"
      />
    </div>
    <div class="participant-loadmore" @click="handleGo" v-if="hasMore">
      <span>{{ loading ? 'Loading...' : 'More' }}</span>
      <svg
        width="19"
        height="18"
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="{ 'animate-spin': loading }"
      >
        <path
          d="M4.66992 6.75L9.16992 11.25L13.6699 6.75"
          stroke="#999999"
          style="stroke: #999999; stroke: color(display-p3 0.6 0.6 0.6); stroke-opacity: 1"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import ParticipantsCardItem from './ParticipantsCardItem.vue'
import { fetchApi } from '@/utils.js'

const items = ref([])
const pagination = ref({
  page: 1,
  pageSize: window.innerWidth < 768 ? 2 : 6
})

const participantsVisible = ref(false)

const participantId = ref(null)

const participantData = ref({})

const loading = ref(false)
const hasMore = ref(true)

const fetchParticipants = async (isLoadMore = false) => {
  if (loading.value) return

  loading.value = true
  try {
    const { items: data, meta } = await fetchApi('/v1/participant/list', {
      query: {
        page: pagination.value.page,
        pageSize: pagination.value.pageSize,
        isValid: 1,
        field: 'sortValue',
        order: 'ASC'
      }
    })

    if (isLoadMore) {
      items.value = [...items.value, ...data]
    } else {
      items.value = data
    }

    hasMore.value = items.value.length < meta.totalItems
    if (hasMore.value) {
      pagination.value.page++
    }
  } catch (error) {
    console.error('Failed to fetch participants:', error)
  } finally {
    loading.value = false
  }
}

function handelItem(item) {
  console.log(item, 'handelItem')
  participantsVisible.value = true
  participantId.value = item.id
  participantData.value = item
}

function handleGo() {
  window.open('https://utxoverse.xyz/dashboard?p=v', '_blank')
}

onMounted(() => {
  fetchParticipants()
})
</script>

<style scoped lang="scss">
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.participant {
  padding: 0 30px;
  @include sm {
    width: 100%;
    padding: 0 20px;
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
}
.participant-head {
  color: #f5f5f5;
  text-align: center;
  font-family: 'Satoshi Variable';
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 36px */
  margin-bottom: 16px;
  margin-top: 106px;
  @include sm {
    margin-top: 36px;
  }
}
.participant-list {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-row-gap: 16px;
  grid-column-gap: 12px;
  margin-bottom: 16px;

  @include sm {
    grid-template-columns: 1fr;
    grid-row-gap: 24px;
  }
}
.participant-loadmore {
  display: flex;
  padding-top: var(--spacing-md, 8px);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  cursor: pointer;
  span {
    color: var(--Colors-Text-text-tertiary, #8c8c8c);
    text-align: center;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
}
</style>
